import React, { useEffect, useState } from "react";
import { apiUrl } from "../../config";

const SliderList = ({ slides, onEdit, onDelete, onView }) => {
    if (!Array.isArray(slides) || slides.length === 0) {
        return (
            <div className="text-center py-5">
                <p className="text-muted fs-5">No slides found</p>
            </div>
        );
    }

    return (
        <div className="row g-4">
            {slides.map((slide, index) => (
                <SlideCard
                    key={slide.id || index}
                    slide={slide}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onView={onView}
                />
            ))}
        </div>
    );
};

const SlideCard = ({ slide, onEdit, onDelete, onView }) => {
    const [backgroundGradient, setBackgroundGradient] = useState("");

    useEffect(() => {
        if (slide.bgColor1 && slide.bgColor2) {
            setBackgroundGradient(
                `linear-gradient(135deg, ${slide.bgColor1}, ${slide.bgColor2})`
            );
        }
    }, [slide.bgColor1, slide.bgColor2]);

    return (
        <div className="col-12 col-md-6 col-xl-4">
            <div
                className="card border-0 shadow-lg rounded-4 overflow-hidden position-relative hover-lift"
                style={{ transition: "all 0.3s ease" }}
            >
                {/* Floating action buttons - top right */}
                <div
                    className="position-absolute d-flex gap-2"
                    style={{
                        top: "12px",
                        right: "12px",
                        zIndex: 10,
                    }}
                >
                    <button
                        className="btn btn-sm rounded-circle"
                        style={{ backgroundColor: "#17a2b8", width: "42px", height: "42px" }}
                        title="View"
                        onClick={() => onView(slide)}
                    >
                        <i className="fas fa-eye text-white fs-5"></i>
                    </button>
                    <button
                        className="btn btn-sm rounded-circle"
                        style={{ backgroundColor: "#ffc107", width: "42px", height: "42px" }}
                        title="Edit"
                        onClick={() => onEdit(slide)}
                    >
                        <i className="fas fa-edit text-white fs-5"></i>
                    </button>
                    <button
                        className="btn btn-sm rounded-circle"
                        style={{ backgroundColor: "#dc3545", width: "42px", height: "42px" }}
                        title="Delete"
                        onClick={() => onDelete(slide.id)}
                    >
                        <i className="fas fa-trash text-white fs-5"></i>
                    </button>
                </div>

                {/* Gradient header */}
                <div
                    className="p-4 d-flex align-items-center"
                    style={{ background: backgroundGradient }}
                >
                    {slide.imageUrl && (
                        <img
                            src={
                                typeof slide.imageUrl === "string"
                                    ? (slide.imageUrl.startsWith("http")
                                        ? slide.imageUrl
                                        : `${apiUrl}/${slide.imageUrl}`)
                                    : URL.createObjectURL(slide.imageUrl)
                            }
                            alt="Slide"
                            className="rounded shadow-lg"
                            style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                                border: "4px solid #fff",
                                borderRadius: "14px",
                            }}
                        />
                    )}
                    <div className="ms-3">
                        <h5
                            className="mb-1 fw-bold"
                            style={{ color: slide.titleColor || "#fff" }}
                        >
                            {slide.title}
                        </h5>
                        {slide.name && (
                            <p className="mb-1" style={{ color: slide.nameColor || "#f8f9fa" }}>
                                {slide.name}
                            </p>
                        )}
                        {slide.description && (
                            <p className="small mb-0" style={{ color: slide.descriptionColor }}>
                                {slide.description}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SliderList;
